import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

import useLocales from 'src/hooks/useLocales';
// _mock_

// components

import ContractTypeNewEditForm from './POSNewEditForm';

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
// sections

// @type

// ----------------------------------------------------------------------

export default function ContractTypeCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit
          ? `${translate('ContractType.AddTitle')}`
          : `${translate('ContractType.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        {/* <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('ContractType.CreateContractType')}`
              : `${translate('ContractType.EditContractType')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('ContractType.ContractTypeList')}`,
              href: PATH_DASHBOARD.ContractDetails.list,
            },
            {
              name: !isEdit
                ? `${translate('ContractType.New')}`
                : `${translate('ContractType.Update')}`,
            },
          ]}
        /> */}
        <ContractTypeNewEditForm />
      </Container>
    </Page>
  );
}
